import { createAssetInfo, FungibleConditionCode, makeContractFungiblePostCondition, makeContractNonFungiblePostCondition, makeContractSTXPostCondition, makeStandardFungiblePostCondition, makeStandardNonFungiblePostCondition, makeStandardSTXPostCondition, NonFungibleConditionCode } from "@stacks/transactions";
import { authenticatedUserAddress } from "./auth";
import { clientNetwork } from "../lib/constants";

const userAddress = authenticatedUserAddress({ network: clientNetwork });

export function mergePostConditions(postConditionsArray) {
    return postConditionsArray.reduce((acc, current) => {
        const foundIndex = acc.findIndex(item => item.contractAddress === current.contractAddress);

        if (foundIndex > -1) {
            // Merge values of duplicates by summing them
            acc[foundIndex].value += current.value;
        } else {
            // Add new entry if not a duplicate
            acc.push(current);
        }

        return acc;
    }, []);
}

export const dynamicPostConditionListForUsers = (list) => {
    if (!Array.isArray(list)) return [];

    const makePostConditionMethod = {
        'ft': makeStandardFungiblePostCondition,
        'nft': makeStandardNonFungiblePostCondition,
        'stx': makeStandardSTXPostCondition,
        'cft': makeContractFungiblePostCondition,
        'cnft': makeContractNonFungiblePostCondition,
        'cstx': makeContractSTXPostCondition
    };

    return list.map(({ type, contractAddress, value }) => {
        const extContractAddress = contractAddress?.split('.')[0];
        const extContractName = contractAddress?.split('.')[1]?.split('::')[0];
        const extAssetName = contractAddress?.split('::')[1];
        const assetInfo = createAssetInfo(extContractAddress, extContractName, extAssetName);

        return {
            'ft': () => makePostConditionMethod[type](userAddress, FungibleConditionCode.LessEqual, value, assetInfo),
            'nft': () => makePostConditionMethod[type](userAddress, NonFungibleConditionCode.DoesNotSend, assetInfo, value),
            'stx': () => makePostConditionMethod[type](userAddress, FungibleConditionCode.LessEqual, value),
            // From here is for contract conditions
            'cft': () => makePostConditionMethod[type](userAddress, extContractName, FungibleConditionCode.LessEqual, value, assetInfo),
            'cnft': () => makePostConditionMethod[type](userAddress, extContractName, NonFungibleConditionCode.DoesNotSend, assetInfo, value),
            'cstx': () => makePostConditionMethod[type](userAddress, extContractName, FungibleConditionCode.LessEqual, value),
        }[type]();
    });
}